import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome';
import { forwardRef } from 'react';

type ForwardRefIconProps = {
  icon: FontAwesomeIconProps['icon'];
  className?: FontAwesomeIconProps['className'];
};

export const ForwardRefIcon = forwardRef<SVGSVGElement, ForwardRefIconProps>(
  (props, ref) => <FontAwesomeIcon ref={ref} {...props} />
);

ForwardRefIcon.displayName = 'ForwardRefIcon';
